<template>
  <div class="component-container">
    <div class="title">基本信息</div>
    <el-form
      ref="form"
      label-width="105px"
      label-position="right"
      size="small"
      :rules="rules"
      :model="form"
    >
      <el-form-item
        class="form-content"
        size="small"
        label="姓名："
        prop="nickname"
      >
        <el-input
          v-model="form.nickname"
          clearable
          placeholder="请输入姓名"
        ></el-input>
      </el-form-item>
      <el-form-item
        class="form-content"
        size="small"
        label="电话："
        prop="phone"
      >
        <el-input
          v-model="form.phone"
          clearable
          onkeyup="value=value.replace(/[^\d]/g,'')"
          placeholder="请输入电话"
          @input="oninputPhoneClick(0, form.phone)"
        ></el-input>
      </el-form-item>
      <el-form-item class="form-content" size="small" label="性别：" prop="sex">
        <el-select v-model="form.gender" size="mini">
          <el-option
            v-for="item in sexOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        class="form-content"
        size="small"
        label="地区："
        prop="area"
      >
        <AddrssSelect ref="area" :value="'1'" @address="getAddress" />
      </el-form-item>
      <el-form-item
        class="form-content"
        size="small"
        label="地址："
        prop="address"
      >
        <el-input
          v-model="form.address"
          clearable
          placeholder="请输入地址"
        ></el-input>
      </el-form-item>
      <el-form-item
        class="form-content"
        size="small"
        label="简介："
        prop="description"
      >
        <el-input
          type="textarea"
          v-model="form.description"
          :autosize="{ minRows: 4, maxRows: 8 }"
          placeholder="请输入简介"
        ></el-input>
      </el-form-item>
      <el-form-item class="form-content">
        <el-button
          class="button-sure"
          size="small"
          type="primary"
          :loading="uploading"
          @click="onSureClick"
          >提交</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import AddrssSelect from "@/components/AddressSelect";
import { getCustomerView, getCustomerSave } from "@/api/accountcenter";
export default {
  name: "BasicInformation",
  components: {
    AddrssSelect,
  },
  data() {
    return {
      form: {
        nickname: "",
        phone: "",
        gender: 1,
        address: "",
        description: "",
      },
      addressData: {},
      uploading: false,
      sexOptions: [
        {
          id: 1,
          name: "男",
        },
        {
          id: 0,
          name: "女",
        },
      ],
      rules: {
        nickname: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        phone: [{ required: true, message: "请输入电话", trigger: "blur" }],
        gender: [{ required: true, message: "请选择性别", trigger: "blur" }],
        area: [
          {
            required: true,
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (Object.keys(this.addressData).length > 0) {
                callback();
              } else {
                callback(new Error("请选择地区"));
              }
            },
          },
        ],
        address: [{ required: true, message: "请输入地址", trigger: "blur" }],
        description: [
          { required: true, message: "请输入简介", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    this._getCustomerView();
  },
  methods: {
    oninputPhoneClick(index, value) {
      value = value.replace(/[^\d]/g, "");
      this.$set(this.form, "mobile", value);
    },
    /**
     * 获取地址
     */
    getAddress(datas) {
      this.addressData = datas;
      console.log(datas);
    },
    onSureClick() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this._getCustomerSave();
        } else {
          return false;
        }
      });
    },
    //会员信息
    _getCustomerView() {
      getCustomerView()
        .then((res) => {
          const {
            data,
            data: { provinceCode, cityCode, districtCode },
          } = res;
          this.form = {
            ...this.form,
            ...data,
          };
          this.addressData = {
            province: provinceCode,
            city: cityCode,
            area: districtCode,
          };
          this.$refs.area.parentHandleclick(this.addressData);
        })
        .catch(() => {});
    },
    //保存会员信息
    _getCustomerSave() {
      this.uploading = true;
      const { province, city, area } = this.addressData;
      getCustomerSave({
        ...this.form,
        provinceCode: province,
        cityCode: city,
        districtCode: area,
      })
        .then((res) => {
          this.uploading = false;
          const { message } = res;
          this.$message.success(message || "修改成功");
        })
        .catch(() => {
          this.uploading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.component-container {
  width: 1040px;
  height: 650px;
  background: #ffffff;
  box-shadow: 0px 0px 6px 2px rgba(16, 130, 255, 0.3);
  .title {
    text-align: left;
    height: 60px;
    line-height: 60px;
    margin-left: 20px;
    margin-right: 20px;
    font-size: 18px;
    border-bottom: 1px solid #eeeeee;
    color: #333333;
  }
  .form-content {
    margin-top: 20px;
    width: 520px;
    text-align: left;
    .el-select {
      width: 100%;
    }
    .button-sure {
      margin-top: 60px;
      width: 120px;
      height: 50px;
      font-size: 18px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/accountcenter/components/basicinformation.vue